import { useIntl } from 'react-intl';

import qrCode from '../../../../assets/images/qr-code-eye.svg';
import { useStyles } from './download-app.styles';
import { downloadAppLinks } from './download-app-links';
import { ICON_SIZE_40 } from '../../../../constants/icon-sizes';

const ICON_WIDTH = 135;

export const DownloadApp = (): JSX.Element => {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <div className={classes.apps} data-testid='download-app'>
      <div className={classes.qrCode} data-testid='qr-code'>
        <img
          src={qrCode}
          alt={intl.formatMessage({ id: 'common.qrCode' })}
          width="124"
          height="124"
        />
      </div>
      <ul className={classes.stores}>
        {downloadAppLinks.map(({ href, Icon, testId }) => (
          <li key={testId}>
            {/* Don't remove data-testid, it is used by Yandex Metrica */}
            <a href={href} target='_blank' rel='noopener noreferrer' data-testid={testId}>
              <Icon width={ICON_WIDTH} height={ICON_SIZE_40} className={classes.icon} />
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};
